import { axiosInstance, axiosCompanyPortalInstance } from "./";

const BULK_STATUS_VALIDATE = (status) =>
  (status >= 200 && status < 300) || status === 207;

const instanceFor = (portalVariant) =>
  portalVariant === "admin-portal" ? axiosInstance : axiosCompanyPortalInstance;

const bulkAssignTag = (portalVariant, data) =>
  instanceFor(portalVariant).post("/user_tags/bulk_assign_tag", data, {
    validateStatus: BULK_STATUS_VALIDATE,
  });

const bulkRemoveTag = (portalVariant, data) =>
  instanceFor(portalVariant).post("/user_tags/bulk_remove_tag", data, {
    validateStatus: BULK_STATUS_VALIDATE,
  });

export { bulkAssignTag, bulkRemoveTag };
